import styled from 'styled-components';

import { PowerBars } from '../../../../components/Toolkit/UpsellCard/components/PowerBars/PowerBars';
import { Button } from '../../../../components/Toolkit/Button/Button';
import { BulletPointList } from '../../../../components/Toolkit/UpsellCard/components/BulletPointList/BulletPointList';

import { media } from '../../../../helpers/breakpoints';

type TVariant = 'DEFAULT' | 'WIDE';

export const ButtonText = styled.span`
  margin-left: ${({ theme }) => theme.spacing.S8};
  color: ${({ theme }) => theme.colors.BLUE};
`;

export const Border = styled.div<TContainer>`
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  border: ${({ theme, selected, hasError }) =>
    hasError
      ? `2px solid ${theme.colors.RED_DARK};`
      : selected
      ? `2px solid ${theme.colors.BLUE}`
      : `2px solid transparent`};
  width: 100%;
  height: 100%;
  box-shadow: ${({ theme, selected, hasError }) =>
    selected || hasError ? theme.shadow.CONTAINER : undefined};
`;

export const WeRecommendBanner = styled.div<TContainer>`
  ${({ theme }) => theme.fontSize.M14};
  background-color: ${({ theme }) => theme.colors.GREY_DARKER};
  color: ${({ theme }) => theme.colors.WHITE};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  padding: ${({ theme }) => theme.spacing.S4};

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;

type TContainer = {
  selected?: boolean;
  hasError: boolean;
  variant: TVariant;
  isWeRecommend?: boolean;
};
export const Wrapper = styled.div<TContainer>`
  max-width: 680px;
  height: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background: ${({ theme }) => theme.colors.WHITE};
  box-shadow: ${({ theme, selected, hasError }) =>
    !selected && !hasError ? theme.shadow.CONTAINER : undefined};
  background-color: ${({ theme }) => theme.colors.WHITE};

  ${({ variant }) => (variant === 'DEFAULT' ? media.large : media.medium)} {
    display: flex;
    height: 100%;
    flex-direction: column;
  }

  &:hover {
    cursor: default;
  }
`;

export const Price = styled.p`
  ${({ theme }) => theme.fontSize.H24};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.GREY_DARKER};

  ${media.large} {
    ${({ theme }) => theme.fontSize.H32};
  }
`;

export const FlexBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.M24};

  ${media.large} {
    flex-direction: column;
    justify-content: center;
  }
`;

export const Title = styled.p`
  ${({ theme }) => theme.fontSize.L18};
  color: ${({ theme }) => theme.colors.GREY_DARKER};

  ${media.large} {
    margin-bottom: 0;
  }
`;

export const SPowerBars = styled(PowerBars)`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export const SBulletPointList = styled(BulletPointList)`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export const SButton = styled(Button)<{ selected: boolean }>`
  ${({ selected, theme }) =>
    selected ? `border: 1px solid ${theme.colors.BLUE}` : undefined};
`;

export const Content = styled.div<TContainer>`
  padding: ${({ theme, isWeRecommend }) =>
    isWeRecommend
      ? `${theme.spacing.L48} ${theme.spacing.M24} ${theme.spacing.M24}`
      : theme.spacing.M24};
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  ${media.large} {
    padding: ${({ theme, isWeRecommend }) =>
      isWeRecommend
        ? `${theme.spacing.L48} ${theme.spacing.M16} ${theme.spacing.L40}`
        : `${theme.spacing.M32} ${theme.spacing.M16} ${theme.spacing.M24}`};
  }
`;
